export const branchRouter = [{
    path: '',
    redirect: 'index'
},
    {
        path: 'index',
        meta: {
            title: '首页',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/index'),
    },
    {
        path: 'notice/list',
        meta: {
            title: '通知公告',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/notice/list'),
    },
    {
        path: 'notice',
        meta: {
            title: '通知公告',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/branch/page/notice/notice'),
    },
    {
        path: 'notice/edit/:id',
        meta: {
            title: '通知公告编辑',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/notice/edit'),
    },
    {
        path: 'notice/detail/:id',
        meta: {
            title: '通知公告详情',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/notice/detail'),
    },
    {
        path: 'message/list',
        meta: {
            title: '短信群发',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/message/list'),
    },
    {
        path: 'message/send',
        meta: {
            title: '短信群发',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/message/send'),
    },
    {
        path: 'members/list',
        meta: {
            title: '会员信息',
            needLogin: true , // 是否需要登录才能访问
            keepAlive: true
        },
        component: () =>
            import ('../views/branch/page/members/list'),
    },
    {
        path: 'members/slist',
        meta: {
            title: '会员信息',
            needLogin: true , // 是否需要登录才能访问
            keepAlive: true
        },
        component: () =>
            import ('../views/branch/page/members/slist'),
    },
    {
        path: 'members/draft',
        meta: {
            title: '草稿箱',
            needLogin: true , // 是否需要登录才能访问
            keepAlive: true
        },
        component: () =>
            import ('../views/branch/page/members/draft'),
    },
    {
        path: 'members/sdraft',
        meta: {
            title: '草稿箱',
            needLogin: true , // 是否需要登录才能访问
            keepAlive: true
        },
        component: () =>
            import ('../views/branch/page/members/sdraft'),
    },
    {
        path: 'members/info/:id/:type',
        meta: {
            title: '会员基本信息',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/members/info'),
    },
    {
        path: 'members/certificate/:id',
        meta: {
            title: '会员证书',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/members/certificate'),
    },
    {
        path: 'members/exam',
        meta: {
            title: '会员审核',
            needLogin: true, // 是否需要登录才能访问
            keepAlive: true
        },
        component: () =>
            import ('../views/branch/page/members/exam'),
    },
    {
        path: 'members/examInfo/:id',
        meta: {
            title: '会员信息审核',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/members/examInfo'),
    },

    {
        path: 'setup/level',
        meta: {
            title: '级别设置',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/setup/level'),
    },
    {
        path: 'setup/label',
        meta: {
            title: '标签设置',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/setup/label'),
    },
    {
        path: 'setup/invitation',
        meta: {
            title: '会员邀请',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/setup/invitation'),
    },
    {
        path: 'setup/information',
        meta: {
            title: '信息设置',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/setup/information'),
    },
    {
        path: 'setup/sinformation',
        meta: {
            title: '信息设置',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/setup/sinformation'),
    },
    {
        path: 'setup/explain',
        meta: {
            title: '会员说明',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/setup/explain'),
    },
    {
        path: 'setup/explainArticle/:type/:id',
        meta: {
            title: '会员说明',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/setup/explainArticle'),
    },
    {
        path: 'setup/explainType/:type/:name',
        meta: {
            title: '会员说明',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/setup/explainType'),
    },
    {
        path: 'setup/certificate',
        meta: {
            title: '证书设置',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/setup/certificate'),
    }, {
        path: 'setup/scertificate',
        meta: {
            title: '证书设置',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/setup/scertificate'),
    },
    {
        path: 'members/fcertificate',
        meta: {
            title: '分会聘书',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/members/fcertificate'),
    },
    {
        path: 'fee/cost',
        meta: {
            title: '会费管理',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/fee/cost'),
    },
    {
        path: 'fee/invoice',
        meta: {
            title: '开票记录',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/fee/invoice'),
    },
    {
        path: 'fee/pay',
        meta: {
            title: '支付设置',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/fee/pay'),
    },
    {
        path: 'organ/info',
        meta: {
            title: '机构信息',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/organ/info'),
    },
    {
        path: 'organ/dynamic',
        meta: {
            title: '机构动态',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/organ/dynamic'),
    },
    {
        path: 'organ/dynamicEdit/:id',
        meta: {
            title: '机构动态',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/organ/dynamicEdit'),
    },
    {
        path: 'organ/activity',
        meta: {
            title: '机构活动 ',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/organ/activity'),
    },
    {
        path: 'organ/server',
        meta: {
            title: '机构服务',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/organ/server'),
    },
    {
        path: 'organ/serverEdit/:id',
        meta: {
            title: '机构服务编辑',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/organ/serverEdit'),
    },
    {
        path: 'organ/serverDetail/:id',
        meta: {
            title: '机构服务详情',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/organ/serverDetail'),
    },
    {
        path: 'organ/password',
        meta: {
            title: '修改密码',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
          import ('../views/branch/page/organ/password'),
    },
    {
        path: 'organ/account',
        meta: {
            title: '子账号管理',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
          import ('../views/branch/page/organ/account'),
    },
    {
        path: 'members/sonPower/:id',
        meta: {
            title: '子账号管理权限',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
          import ('../views/branch/page/organ/sonPower'),
    },
    {
        path: 'service/list',
        meta: {
            title: '服务中心',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/branch/page/service/list'),
    },
    {
        path: 'service/detail',
        meta: {
            title: '服务详情',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/branch/page/service/detail'),
    },
    {
        path: 'service/record',
        meta: {
            title: '申请记录',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/branch/page/service/record'),
    },
    {
        path: 'server/serverList',
        meta: {
            title: '客服管理',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/server/serverList'),
    },
    {
        path: 'server/serverEdit',
        meta: {
            title: '客服编辑',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/server/serverEdit'),
    },
    {
        path: 'server/question',
        meta: {
            title: '常见问题',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/server/question'),
    },
    {
        path: 'server/questionEdit',
        meta: {
            title: '常见问题编辑',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/server/questionEdit'),
    },
    {
        path: 'server/opinion',
        meta: {
            title: '意见反馈',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/server/opinion'),
    },
    {
        path: 'statistics/statistics',
        meta: {
            title: '数据统计',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/branch/page/statistics/statistics'),
    },

]

export default branchRouter
